var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26847 0 0 6.26847 0 14C0 21.7324 6.26847 28 14 28C21.7324 28 28 21.7333 28 14C28 6.26847 21.7323 0 14 0ZM14 25.375C7.71754 25.375 2.62504 20.2825 2.62504 14C2.62504 7.71754 7.71754 2.62504 14 2.62504C20.2825 2.62504 25.375 7.71754 25.375 14C25.375 20.2825 20.2825 25.375 14 25.375ZM14.0009 6.13985C12.9982 6.13985 12.2395 6.66313 12.2395 7.50836V15.2608C12.2395 16.1069 12.9981 16.6285 14.0009 16.6285C14.9791 16.6285 15.7623 16.0851 15.7623 15.2608V7.50836C15.7622 6.6832 14.9791 6.13985 14.0009 6.13985ZM14.0009 18.375C13.0375 18.375 12.2535 19.1591 12.2535 20.1232C12.2535 21.0857 13.0375 21.8697 14.0009 21.8697C14.9643 21.8697 15.7474 21.0857 15.7474 20.1232C15.7473 19.159 14.9643 18.375 14.0009 18.375Z",
    fill: "#D0D0D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3d711e99.svg";
export { ForwardRef as ReactComponent };